import { render, staticRenderFns } from "./cps.vue?vue&type=template&id=24b84a62&scoped=true"
import script from "./cps.vue?vue&type=script&lang=js"
export * from "./cps.vue?vue&type=script&lang=js"
import style0 from "./cps.vue?vue&type=style&index=0&id=24b84a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b84a62",
  null
  
)

export default component.exports